<template>
  <div class="block pb-1">
    <div class="flex justify-center items-center my-10" v-if="!armadaHistory">-- No Data --</div>
    <template v-else>
      <TableComponent :columns="columns" :list="armadaHistory">
        <template slot="table-row" slot-scope="{ entry, column }">
          <span class="block" v-if="column.field === 'created_time'">
            {{ entry[column.field] | formatDate }}
          </span>
          <span v-else>{{ entry[column.field] }}</span>
        </template>
      </TableComponent>
    </template>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { formatDate } from '@/util'
export default {
  filters: {
    formatDate
  },
  components: {
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table')
  },
  data() {
    return {
      searchTerm: '',
      totalRecords: 0,
      currentPage: 1,
      pageSize: 1,
      hasMorePages: true,
      columns: [
        { label: 'Tanggal', field: 'created_time' },
        { label: 'Driver', field: 'name' },
        { label: 'Asal', field: 'from_area_code' },
        { label: 'Tujuan', field: 'to_area_code' },
        { label: 'Jarak', field: 'distance_in_meter' }
      ],
      data: [
        {
          date: '16 Oct 2021',
          driver: 'Hartaka Darmanto',
          origin: 'Bogor',
          destination: 'Jakarta Selatan',
          distance: '43KM'
        },
        {
          date: '16 Oct 2021',
          driver: 'Hartaka Darmanto',
          origin: 'Bogor',
          destination: 'Jakarta Selatan',
          distance: '43KM'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('auth', ['userData']),
    ...mapGetters('armada', ['armadaHistory']),
    vehicleId() {
      return this.$route.params.id
    },
    partnerId() {
      return this.userData?.user?.group_id
    },
    filteredData() {
      let temp = this.armadaHistory || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    }
  },
  created() {
    this.getVehicleHistory()
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading']),
    ...mapActions('armada', ['getArmadaHistory']),
    getVehicleHistory(searchTerm = '') {
      this.showLoading()
      this.getArmadaHistory({
        partnerId: this.partnerId,
        vehicleId: this.vehicleId,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: searchTerm,
          sort: 'DESC'
        }
      }).then(res => {
        // console.log(res)
        this.hideLoading()
        this.totalRecords = res.data.meta.total_item
      })
    },
    onPageChange(page) {
      this.currentPage = page
      this.getVehicleHistory()
      // this.$router.push({ path: '/armada', query: { page: page } })
    }
  }
}
</script>
